export class PaginacaoParamModel {
  paginaAtual: Number = 1;
  registrosPorPagina: Number = 24;
}
